import { getApiHost } from '@hotjar/common';
import { log } from '@hotjar/insights-common/lib/log';

function getOrRaise(kwargs, attribute) {
    if (typeof kwargs[attribute] === 'undefined') {
        throw new Error(attribute + ' must be specified.');
    }
    return kwargs[attribute];
}

function getApiUrl(baseUrl, version, defaultApiVersion, apiPrefix) {
    let apiUrl = baseUrl;
    if (apiPrefix) {
        apiUrl += `${apiPrefix}/`;
    }
    return apiUrl + `v${version || defaultApiVersion}`;
}

/**
 * Construct an URL from the kwargs given.
 */
export function constructUrl(baseUrl, defaultApiVersion, kwargs) {
    var apiEndpoint = getOrRaise(kwargs, 'apiEndpoint'),
        localKwargs = _.clone(kwargs),
        qs = [],
        url,
        version = kwargs.version;

    delete localKwargs['apiEndpoint'];
    delete localKwargs['apiPrefix'];
    if (version) {
        delete localKwargs['version'];
    }

    // Filtering.
    if (localKwargs.filters) {
        localKwargs.filter = _.map(localKwargs.filters, function (filter) {
            return filter.field + '__' + filter.operation + '__' + filter.value;
        });
        delete localKwargs['filters'];
    }

    // Sorting.
    if (localKwargs.sort) {
        localKwargs.sort = _.map(localKwargs.sort, function (s) {
            return (s.descending ? '-' : '') + s.by;
        });
    }

    // Generate querystring.
    for (var arg in localKwargs) {
        // Only add them in if they're not false.
        if (!_.isUndefined(localKwargs[arg]) && localKwargs[arg] !== false) {
            qs.push(
                arg +
                    '=' +
                    encodeURIComponent(_.isArray(localKwargs[arg]) ? localKwargs[arg].join(',') : localKwargs[arg])
            );
        }
    }

    url = getApiUrl(baseUrl, version, defaultApiVersion, kwargs.apiPrefix) + apiEndpoint;
    if (qs.length) {
        url += '?' + qs.join('&');
    }

    return url;
}

/**
 * GQSR (Generic Query String Request) handler.
 *
 * https://hotjar.atlassian.net/wiki/display/DEV/GQSR+-+Generic+Query+String+Request
 */
angular.module('hjApp').service('GQSR', [
    '$http',
    '$q',
    'DownloadBlob',
    'Notify',
    'restDefaultHandlers',
    function ($http, $q, DownloadBlob, Notify, restDefaultHandlers) {
        var defaultApiVersion = 1,
            BASE_URL = `${getApiHost()}/api/`;

        /**
         * GQSR Get request.
         */
        this.get = function (kwargs, callback) {
            return $http({
                method: 'GET',
                url: constructUrl(BASE_URL, defaultApiVersion, kwargs)
            })
                .then(
                    function onSuccess(res) {
                        if (!res.data.success && res.data.error === 'Bad Request') {
                            log.warn(
                                'Bad GQSR request. Trying to request / filter / sort fields you are not allowed to?'
                            );
                            return $q.reject(res);
                        } else {
                            if (callback) callback(res.data);
                            return res.data;
                        }
                    },
                    function (res) {
                        restDefaultHandlers.onError(res);

                        return $q.reject(res);
                    }
                )
                .catch(function onReject(message) {
                    log.warn('GQSR get failed: ' + message);
                });
        };

        /**
         * Download a file with a GQSR request.
         */
        this.download = function (kwargs, fileName) {
            DownloadBlob.open(constructUrl(BASE_URL, defaultApiVersion, kwargs), fileName)
                .then(function () {})
                .catch(function (res) {
                    if (res.status == 413) {
                        Notify.error('Feedback amount selected too large, please select a smaller amount');
                    } else {
                        Notify.unhandledError();
                    }
                });
        };
    }
]);
